__turbopack_context__.v({
  "bgImage": "TUezLa_bgImage",
  "bgImageContainer": "TUezLa_bgImageContainer",
});
